import type { CatalogUerBaseCostWorkScopeData, CollectionUerBaseCostWorkScopeData } from 'gql/graphql';

import { useEffect, useState } from 'react';

import type { IRowWithCommonOptions } from '../types';

interface IUseUpdatePriceWorkScopeData {
    items: CollectionUerBaseCostWorkScopeData[] | CatalogUerBaseCostWorkScopeData[];
}

export const useUpdatePriceWorkScopeData = (props: IUseUpdatePriceWorkScopeData) => {
    const { items } = props;

    const [localRowState, setLocalRowState] = useState<IRowWithCommonOptions[]>([]);

    useEffect(() => {
        if (items && !localRowState?.length) {
            setLocalRowState(
                items?.map((i) => ({
                    ...i,
                    id: i?.number,
                })),
            );
        }
    }, [items, localRowState?.length]);

    useEffect(
        () => () => {
            setLocalRowState([]);
        },
        [],
    );

    return localRowState;
};
